<template>
  <div>
    <v-card max-width="465px" height="100%">
      <v-card-title
        class="card-title py-2"
        v-if="(!isMember || !isMembershipValid) && !workshopDetails.is_bought"
      >
        <v-row class="ma-0" justify="center" align="center">
          Join 500+ Special Educators today!
        </v-row>
      </v-card-title>
      <v-card-text
        id="non-active-member"
        class="px-2 px-sm-8 pt-4"
        v-if="(!isMember || !isMembershipValid) && !workshopDetails.is_bought"
      >
        <v-col align="center" class="card-heading" v-html="getCardHeading()" />

        <v-row class="ma-0 py-4 px-4">
          <v-img
            class="mx-2"
            max-width="32px"
            max-height="32px"
            aspect-ratio="1"
            src="@/assets/workshop/Wave-Check.svg"
          />
          <v-col class="pa-0">
            <div class="bullet-title">Get access to this workshop</div>
            <div v-if="!planLoading" class="bullet-cost">
              Worth
              {{
                membershipDetails.currency_details.symbol +
                  workshopDetails.amount
              }}
            </div>
          </v-col>
        </v-row>

        <v-row class="ma-0 py-4 px-4">
          <v-img
            class="mx-2"
            max-width="32px"
            max-height="32px"
            aspect-ratio="1"
            src="@/assets/workshop/Star.svg"
          />
          <v-col class="pa-0">
            <div class="bullet-title">
              Get access to
              <span @click="showPopUp" class="underline-text-pointer">
                6+ more workshops
              </span>
              this month at NO ADDITIONAL COST
            </div>
            <div v-if="!planLoading" class="bullet-cost">
              Worth
              {{
                workshopDetails.country_details.currency_symbol +
                  workshopDetails.amount * 6
              }}
            </div>
          </v-col>
        </v-row>

        <v-btn
          :loading="planLoading"
          color="#FFA425"
          class="white--text mt-4"
          style="width:100%;height:42px"
          @click="createOrder"
        >
          <span class="btn-span">
            {{ getCtaText() }} <br v-if="$store.state.isMobile" />
            <span v-if="!planLoading && !isFirstMembership">
              {{
                membershipDetails.currency_details.symbol +
                  membershipDetails.price
              }}/mo
            </span>
          </span>
        </v-btn>
        <v-col
          align="center"
          style="font-size: 12px;line-height: 16px;color: rgba(51, 51, 51, 0.7);"
        >
          Cancel anytime. Pay one month at a time.
        </v-col>
        <v-col align="center" class="pt-0" v-if="!isUserLoggedIn">
          <v-btn
            text
            class="login-btn"
            color="#506CFF"
            dark
            x-small
            @click="userLogin"
          >
            <span>Login if you are already a member</span>
          </v-btn>
        </v-col>
      </v-card-text>
      <v-card-text id="active-member" v-else-if="!workshopDetails.is_bought">
        <v-img
          class="py-2"
          contain
          max-height="113px"
          src="@/assets/member-gift.svg"
          style="background: rgba(71, 92, 199, 0.2);border-radius: 12px"
        />
        <v-col align="center" class="card-heading">
          Free for you as you are an Eblity Member!
        </v-col>
        <v-col align="center" justify="center" class="free-span">
          <span class="price-span pe-2">
            {{
              workshopDetails.country_details.currency_symbol +
                workshopDetails.amount
            }}
          </span>
          FREE
        </v-col>
        <v-btn
          color="#506CFF"
          class="white--text"
          style="width:100%;height:42px"
          @click="registerForWorkshop"
          :loading="buttonLoading"
        >
          <span class="btn-span">
            Register for FREE
          </span>
        </v-btn>
      </v-card-text>
      <v-card-text id="active-member" v-else-if="workshopDetails.is_bought">
        <v-img
          class="py-2"
          contain
          max-height="113px"
          src="@/assets/member-gift.svg"
          style="background: rgba(71, 92, 199, 0.2);border-radius: 12px"
        />
        <v-col align="center" class="card-heading">
          Thank you for registering
        </v-col>
        <!-- <v-col align="center" justify="center" class="free-span">
          <span class="price-span pe-2">
            {{
              workshopDetails.country_details.currency_symbol +
                workshopDetails.amount
            }}
          </span>
          FREE
        </v-col> -->
        <v-btn
          v-if="workshopDetails.status != 'Scheduled'"
          color="#506CFF"
          class="white--text"
          style="width:100%;height:42px"
          @click="registerForWorkshop"
          :loading="buttonLoading"
        >
          <span class="btn-span">
            Watch Now
          </span>
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Axios from "../../../../../../api/BaseAxios";
  import authToken from "../../../../../../common/authToken";
  import { API_CLIENT_URL, ROUTER_URL } from "../../../../../../constants/urls";
  // import PaymentApiHelper from "../../../../../../../api/common/PaymentApis";
  import SessionSeriesApiHelper from "../../../../../../api/common/SessionSeriesApi";
  import AmplitudeHelper from "../../../../../../amplitude";

  export default {
    name: "EnrolmentCard",
    props: ["workshopDetails"],
    components: {},
    data() {
      return {
        monthlyPlan: null,
        freeTrialPlan: null,
        planLoading: true,
        isMember: false,
        membershipValidiTill: authToken.decodedToken().membership_validity
          ? authToken.decodedToken().membership_validity.replace(/\s/, "T")
          : null,
        isUserLoggedIn: authToken.isCorrectAccessToken(),
        isFirstMembership: authToken.decodedToken().membership_validity
          ? false
          : true,
      };
    },
    created() {
      this.isMember = authToken.decodedToken().is_member;
      this.$store.state.loginClicked = false;
      if (!this.isMember || !this.isMembershipValid) this.getPlans();
    },
    computed: {
      isLoggedIn() {
        return this.$store.state.isLoggedIn;
      },
      membershipDetails: {
        get() {
          return this.$store.state.membership.selectedMembership;
        },
        set(value) {
          this.$store.dispatch("membership/updateSelectedMembership", value);
        },
      },
      buttonLoading: {
        get() {
          return this.$store.state.workshop.buttonLoading;
        },
        set(value) {
          this.$store.dispatch("workshop/updateButtonLoading", value);
        },
      },
      isMembershipValid() {
        if (this.membershipValidiTill) {
          return (
            this.membershipValidiTill > this.workshopDetails.start_date_time
          );
        } else {
          return false;
        }
      },
      isExpired() {
        if (authToken.decodedToken().membership_validity) {
          return (
            new Date(
              authToken.decodedToken().membership_validity.replace(/\s/, "T")
            ) < new Date()
          );
        } else {
          return false;
        }
      },
    },
    watch: {
      isLoggedIn() {
        this.membershipValidiTill = authToken
          .decodedToken()
          .membership_validity.replace(/\s/, "T");
        this.isMember = authToken.decodedToken().is_member;
        this.isUserLoggedIn = authToken.isCorrectAccessToken();
        this.isFirstMembership = authToken.decodedToken().membership_validity
          ? false
          : true;
        if (this.isFirstMembership) {
          this.membershipDetails = this.freeTrialPlan;
        } else {
          this.membershipDetails = this.monthlyPlan;
        }
      },
    },
    methods: {
      getCardHeading() {
        return this.isMember && !this.isMembershipValid
          ? "Extend Your Membership <br />to Attend This Workshop"
          : "Attend this Workshop by <br />becoming an Eblity Member";
      },
      getCtaText() {
        if (this.isFirstMembership) {
          return "Claim your Free Trial now";
        } else {
          if (this.isMember && !this.isMembershipValid) {
            return "Extend your membership at";
          } else if (this.isExpired) {
            return "Renew your membership at";
          } else {
            return "Become an Eblity Member at";
          }
        }

        // return this.isMember && !this.isMembershipValid
        //   ? "Extend your membership at"
        //   : "Become an Eblity Member at";
      },
      getPlans() {
        this.planLoading = true;
        const successHandler = (res) => {
          this.planLoading = false;
          this.monthlyPlan = res.data.data.filter(function(el) {
            return el.type == "Monthly";
          })[0];
          this.freeTrialPlan = res.data.data.filter(function(el) {
            return el.type == "Free Trial";
          })[0];

          if (this.isFirstMembership) {
            this.membershipDetails = this.freeTrialPlan;
          } else {
            this.membershipDetails = this.monthlyPlan;
          }
        };

        const failureHandler = (res) => {
          console.log(res);
          this.planLoading = false;
        };

        let params = {};

        Axios.request_POST(
          API_CLIENT_URL.membershipPlan,
          params,
          {},
          successHandler,
          failureHandler
        );
      },
      createOrder() {
        // AmplitudeHelper.registerAmplitudeEvent(
        //   "choose membership",
        //   this.getEventProperties({})
        // );

        var membershipType =
          this.isExpired || (this.isMember && !this.isMembershipValid)
            ? "renewal"
            : this.isFirstMembership
            ? "free"
            : "new";

        AmplitudeHelper.chooseMemebrshipEvent(
          "workshop detail page",
          membershipType,
          this.getEventProperties({})
        );

        if (this.isFirstMembership) {
          this.membershipDetails = this.freeTrialPlan;
        } else {
          this.membershipDetails = this.monthlyPlan;
        }
        this.$router.push({
          name: ROUTER_URL.publicSession.children.membershipCheckout.name,
        });
      },
      registerForWorkshop() {
        this.buttonLoading = true;
        this.$store.state.payment.sessionSeriesId = this.workshopDetails.id;
        let sessions = [];

        this.$store.state.payment.sessions = sessions;
        this.$store.state.payment.discription = this.workshopDetails.title;
        this.$store.state.payment.amount = this.workshopDetails.amount;

        SessionSeriesApiHelper.enrollForSessionSeries(
          this.$store.state.sessionSeriesDetails.data
        );

        // if (authToken.decodedToken().is_member) {
        //   SessionSeriesApiHelper.enrollForSessionSeries(
        //     this.$store.state.sessionSeriesDetails.data
        //   );
        // } else {
        //   //
        // }
      },
      userLogin() {
        AmplitudeHelper.registerAmplitudeEvent("click login", {
          "workshop name": this.workshopDetails.title,
          location: "workshop detail page",
        });
        this.$store.state.loginClicked = true;
        this.createOrder();
      },
      showPopUp() {
        if (this.$store.state.isMembershipEnabled) {
          AmplitudeHelper.registerAmplitudeEvent("view upcoming topics", {
            "workshop name": this.workshopDetails.title,
            tags: [
              ...new Set(
                this.workshopDetails.tags.map((element) => element.name)
              ),
            ],
            skills: [
              ...new Set(
                this.workshopDetails.skills.map((element) => element.name)
              ),
            ],
            "age group": [
              ...new Set(
                this.workshopDetails.age_groups.map((element) => element.name)
              ),
            ],
          });
        }
        this.$store.state.sessionSeriesDetails.nextEventsPopup = true;
      },
      getEventProperties(properties) {
        properties["workshop name"] = this.workshopDetails.title;

        properties["tags"] = [
          ...new Set(this.workshopDetails.tags.map((element) => element.name)),
        ];
        properties["skills"] = [
          ...new Set(
            this.workshopDetails.skills.map((element) => element.name)
          ),
        ];
        properties["age group"] = [
          ...new Set(
            this.workshopDetails.age_groups.map((element) => element.name)
          ),
        ];
        return properties;
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .login-btn {
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    text-decoration-line: underline;
  }

  .free-span {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
  }

  .price-span {
    font-weight: 900;
    font-size: 26px;
    line-height: 36px;
    text-decoration-line: line-through;
    color: rgba(51, 51, 51, 0.7);
  }

  .btn-span {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }

  .card-title {
    background: #fff2e0;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #333333;
  }
  .card-heading {
    font-weight: 800;
    font-size: 22px;
    line-height: 32px;
    color: #506cff;
  }

  .bullet-title {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
  }
  .bullet-cost {
    font-weight: 900;
    font-size: 12px;
    line-height: 18px;
    color: rgba(51, 51, 51, 0.7);
  }

  .underline-text-pointer {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
